<div
  class="d-inline-flex flex-column gap-3 align-items-center"
  [ngClass]="computedGapClasses()"
>
  <div
    class="spinner-border"
    [ngClass]="computedSpinnerClasses()"
    role="status"
  >
    @if (text() !== '') {
      <span class="visually-hidden">{{ text() }}</span>
    }
  </div>
  @if (text() !== '') {
    <div class="mb-0" [ngClass]="computedTextClasses()">
      {{ text() }}
    </div>
  }
</div>
